import Cd4peError from './Cd4peError';

export default Cd4peError;
